<template>
  <div>
    <a-form-item :wrapper-col="{ offset: 5, span: 13 }">
      <a-spin size="large" v-if="fieldsLoading"></a-spin>

      <a-form-item :class="{'no-bottom-margin': showEndpointSwitch}"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
        v-if="!fieldsLoading"
        label="Send Leads To:"
      >
        <a-radio-group
          name="radioGroup"
          :defaultValue="productionEnabled"
          v-model="productionEnabled"
          @change="onProductionChange"
        >
          <a-radio :value="true">Production</a-radio>
          <a-radio :value="false">Staging</a-radio>
        </a-radio-group>
      </a-form-item>

      <!-- Uncomment for debugging: -->
      <!-- regularEndpoint value: {{regularEndpoint}}
      <br>typeof regularEndpoint: {{typeof regularEndpoint}}
      <br>typeof $props.sendToRegularEndpoint: {{typeof $props.sendToRegularEndpoint}} -->
      <a-form-item
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
        v-if="!fieldsLoading && showEndpointSwitch"
        label="Endpoint:"
      >
      <!-- We had to change the event handling to be inside the 2 <a-radio> buttons instead of in <a-radio-group> because
        it became buggy when the confirm dialog was added (with the v-model value being changed inside the handler) 
        -- if you click Cancel, you can't change the radio form again unless you click the already-clicked value. -->
        <a-radio-group
          name="radioGroup"
          :value="regularEndpoint"
        >
          <a-radio :value="true" @click="onSendToRegularEndpointChange">Regular</a-radio>
          <a-radio :value="false" @click="onSendToRegularEndpointChange">Email</a-radio>
        </a-radio-group>
      </a-form-item>


      <v-jsoneditor
        v-if="!fieldsLoading"
        v-model="jsonObj"
        :plus="false"
        height="400px"
        @error="onError"
        :options="jsonEditOpts"
        ref="jsoneditor"
      ></v-jsoneditor>
      <a-alert
        class="error-message"
        type="error"
        message="Invalid JSON Data"
        banner
        v-if="isErrorJsonData"
      />
    </a-form-item>

    <a-modal
      title="Questions:"
      :visible="modalVisible"
      :confirm-loading="modalLoading"
      @cancel="handleCancel"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
      </template>
      <div class="modal-body">
        <div class="search">
          <a-input v-model="questionSearch" placeholder="Search..."></a-input>
        </div>
        <div v-if="remainingQuestions.length > 0 && !isLoadingQuestions" class="record-list">
          <ul>
            <li class="email-subscribe">
              <a @click="setKeyToEmailSubscribe()">Set as Email Subscribe Field</a>
            </li>
            <li v-for="(item, index) in remainingQuestions" :key="item.key">
              <a
                @click="setKeyToQuestionGuid(index)"
                :disabled="isLoadingQuestions"
                v-html="
                  `${item.data.text}<br /><span>${item.key}</span>`
                "
              ></a>
            </li>
          </ul>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import axios from "axios";
import { mapState, mapActions } from "vuex";
import ATextarea from "ant-design-vue/es/input/TextArea";
import AFormItem from "ant-design-vue/es/form/FormItem";
import VJsoneditor from "v-jsoneditor";
import { Modal, Button } from "ant-design-vue"; //Using same format as above ^ doesn't work
import Vue from "vue";
Vue.use(Modal);
Vue.use(Button);

const guidRegex = /[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}/;

export default {
  components: {
    AFormItem,
    ATextarea,
    VJsoneditor
  },
  computed: {
    ...mapState([
      "apiUrl",
      "fieldsLoading",
      "isErrorJsonData",
      "jsonData",
      "user"
    ]),
    jsonObj: {
      get() {
        return JSON.parse(this.jsonData);
      },
      set(value) {
        // json may not be valid? Just do a try-catch to make sure we've got valid json, otherwise
        // the value will remain the same
        try {
          const jsonData = JSON.stringify(value);
          if (jsonData != this.jsonData) {
            this.$store.commit("setMappingsJson", {
              jsonData,
              isError: false
            });
          } else {
            // no change in the JSON which usually indicates that there was previously an error
            // so make sure it is cleared out.
            this.$store.commit("setJsonErrorStatus", false);
          }
        } catch (e) {
          // do nothing
        }
      }
    },
    remainingQuestions() {
      // see if we need to filter by the search string as well as the validGuids or just the validGuids
      let filterQuestions = this.questions;
      if (this.questionSearch.trim() != "") {
        // need to filter by search string
        const searchStr = this.questionSearch.trim().toLowerCase();
        filterQuestions = this.questions.filter(
          question => question.data.text.toLowerCase().indexOf(searchStr) > -1
        );
      }
      return filterQuestions.filter(
        question => !this.validGuids.some(guid => guid == question.key)
      );
    }
  },
  data() {
    return {
      productionEnabled: this.$props.isProduction,
      regularEndpoint: this.$props.sendToRegularEndpoint,
      jsonEditOpts: {
        mode: "code",
        onValidate: this.validateJson
      },
      // this deals with questionGuids and ensures there is a related record
      // related to them and warns if there isn't.
      validatedGuids: {}, //contains the Promises used to validate each key
      validGuids: [], //contains the actual valid guids
      editor: false,

      selectedRow: -1,
      selectedKey: "",
      modalVisible: false,
      modalLoading: false,
      isLoadingQuestions: false,
      questions: [],
      questionSearch: "",
      emailEndpointJSON: {
        "languageIso3":"eng",
        "countryIso2":"us",
        "email":{"emailAddress":"{{email}}"},
        "person":{},
        "subscriptions":[{"listId":"mDGLSPAFamilySubscribed",
          "channel":"email",
          "clientRegion":"",
          "siteUrl":"https://www.facebook.com/ComeUntoChrist/?fadid={{ad_id}}",
          "subscribed":true}
        ]
      },
      originalJsonData: null,
    };
  },
  methods: {
    ...mapActions(["getLookupTable"]),
    showQuestionsModal() {
      this.modalVisible = true;
    },
    handleCancel(e) {
      this.modalVisible = false;
    },
    async getTable(dataType) {
      this.isLoadingQuestions = true;
      this.questions = [];
      this.questions = await this.getLookupTable("question");
      this.isLoadingQuestions = false;
    },
    // creates a Range object (from Ace editor) based on the currently
    // selected row and the key in that row.
    // when a user selects one of the questions in the modal, grab the guid
    // off of it and replace it in the editor.
    setKeyToQuestionGuid(index) {
      this.editor.replace('"' + this.remainingQuestions[index].key + '":', {
        needle: this.selectedKey
      });
      this.modalVisible = false;
      setTimeout(() => {
        this.questionSearch = "";
      }, 300);
    },
    // special case where they chose the email subscribe options in the question list
    setKeyToEmailSubscribe() {
      const rowStr = this.editor.getSession().getLine(this.selectedRow);
      const editedRow =
        rowStr.replace(this.selectedKey, '"email_subscribe":') +
        '\n  "subscriptions":[],';
      this.editor.replace(editedRow, { needle: rowStr });
      this.modalVisible = false;
      setTimeout(() => {
        this.questionSearch = "";
      }, 300);
    },

    // function that returns back a promise that is essentially a call to the
    // server to validate a question Guid to make sure it is valid.
    checkGuid(guid, lineNo) {
      if (guid in this.validatedGuids) {
        return this.validatedGuids[guid];
      }
      const check = axios
        .request({
          url: `${this.apiUrl}/lookup-data`,
          method: "post",
          headers: {
            Authorization: this.user.signInUserSession.idToken.jwtToken
          },
          params: {
            dataType: "question",
            dataKey: guid,
            action: "LOOKUP_PER_DATAKEY"
          }
        })
        .then(rslt => {
          if (
            rslt.data.status == "ok" &&
            rslt.data.data &&
            rslt.data.data.DataKey == guid
          ) {
            return {
              status: "ok",
              data: JSON.parse(rslt.data.data.FieldData).text,
              lineNo,
              path: [guid]
            };
          }
          return {
            status: "err",
            data: {
              path: [guid],
              message: `${guid} is not a valid question Guid.`
            },
            lineNo
          };
        })
        .catch(err => {
          return {
            path: [guid],
            message: `Problem validating ${guid} on the server.`
          };
        });
      this.validatedGuids[guid] = check;
      return check;
    },
    onError() {
      this.$store.commit("setJsonErrorStatus", true);
    },
    onProductionChange(e) {
      this.$store.commit("setIsProduction", e.target.value);
    },
    onSendToRegularEndpointChange(e) {
      if (confirm('Switching will remove any edits you have done to the JSON. Are you sure you want to switch?')) {

        // e.target.value from the <a-radio> returns string versions of true/false instead of boolean so let's just toggle the value here:
        // this was different from when the handler was in <a-radio-group> wherein boolean was being returned. 
        // See explanation why it was changed in the <a-radio-group> component
        this.regularEndpoint = !this.regularEndpoint;
        // alert(typeof e.target.value)
        this.$store.commit("setSendToRegularEndpoint", this.regularEndpoint);

        // Set the JSON appropriately based on endpoint chosen:
        this.$store.commit("setMappingsJson", {
          jsonData: this.regularEndpoint? (this.originalJsonData): JSON.stringify(this.emailEndpointJSON),
          isError: false
        });

        // Force the json editor to revalidate again in the case the JSON didn't change even after changing the endpoint
        // (i.e. if the saved jsonData in DB is same as the default we use for the emailEndpointJSON)
        this.$refs.jsoneditor.editor.validate();
      }
    },
    validateJson(json) {
      if (!this.editor) {
        // need to wire up the editor for editing
        this.wireEditor();
      }
      const errors = [];
      // guids are the string values of guids found as keys in the document
      const guids = [];
      // these are promises of checks whether the guid is valid or not
      const guidChecks = [];
      if (json) {
        // check on the required fields to make sure they are in there

        // For Regular Endpoints
        if(this.regularEndpoint) {
          ["offerId", "sourceId", "languageId", "confirmationPref", "originatingType"].forEach(
            key => {
              if (!(key in json)) {
                errors.push({
                  path: [],
                  message: `Required property "${key}" missing.`
                });
              } else if (key == "confirmationPref") {
                if (
                  [
                    "NONE",
                    "TEACHING CENTER",
                    "EMAIL",
                    "SMS",
                    "EMAIL_AND_SMS"
                  ].indexOf(json[key]) < 0
                ) {
                  errors.push({
                    path: [key],
                    message: `${key} must be a value of "EMAIL", "SMS", "EMAIL_AND_SMS", "TEACHING CENTER" or "NONE"`
                  });
                }
              }
              else if (key == "originatingType") {
                if (json[key] == '')
                {
                  errors.push({
                    path: [key],
                    message: `${key} cannot be blank`
                  });
                }
              }
            }
          );
        }
        // For Email Endpoints
        else {
          ["subscriptions"].forEach(
            key => {
              if (key == "subscriptions" && Array.isArray(json[key])) {
                json[key].forEach((keyX) => {
                  if (!('clientRegion' in keyX)) {
                    errors.push({
                      path: [key],
                      message: `All subscriptions should have a clientRegion.`
                    });
                  }
                });
              }
            }
          );
        }

        // when a user has indicated an email_subscribe field on a form, there needs to be a subscription field
        // with it to indicate the subscriptions it is being sent to.
        if (json.email_subscribe && json.subscriptions == undefined) {
          errors.push({
            path: ["email_subscribe"],
            message:
              'A "subscriptions" field must be added whenever an "email_subscribe" field exits.'
          });
        }
        for (let key in json) {
          // check for opening/closing curly brackets
          const valStr = json[key].toString();
          if (valStr.indexOf("{{") > -1 && valStr.indexOf("}}") < 0) {
            errors.push({
              path: [key],
              message: `${key} has missing or incomplete closing brackets.`
            });
          } else if (valStr.indexOf("}}") > -1 && valStr.indexOf("{{") < 0) {
            errors.push({
              path: [key],
              message: `${key} has missing or incomplete opening brackets.`
            });
          }

          // see if the key is a guid and validate it
          if (key.length == 36 && key.match(guidRegex)) {
            guids.push(key);
          }
          // subscriptions field is a special field that needs to be checked
          if (key == "subscriptions") {
            if (!Array.isArray(json[key])) {
              errors.push({
                path: [key],
                message:
                  "subscriptions must be an array, in the form of [106867] with no quotes."
              });
            } else if (json[key].length == 0) {
              errors.push({
                path: [key],
                message: `${key} must have a value like [106867].`
              });
            }
          }
        }
        if (guids.length) {
          // have to do this separately so we can know which line it is on
          const lines = this.editor
            .getSession()
            .getDocument()
            .getAllLines();
          for (let x = 0, len = lines.length; x < len; x++) {
            const line = lines[x];
            // loop through the guids found until we see if this has a guid in it
            let foundCount = 0;
            for (const guid of guids) {
              if (line.indexOf(`"${guid}"`) > -1) {
                // found one, go ahead and push it on the checkGuids
                guidChecks.push(this.checkGuid(guid, x));
                foundCount++;
              }
            }
            if (foundCount == guids.length) {
              // found them all
              break;
            }
          }
        }
      }
      if (errors.length) {
        // found errors, mark it as such
        this.onError();
      }
      if (guidChecks.length) {
        this.validGuids = [];

        // need to alter the return to be a promise that gets any guid errors
        return Promise.all(guidChecks).then(rslts => {
          const allErrs = [...errors];
          for (const rslt of rslts) {
            if (rslt.status == "err") {
              allErrs.push(rslt.data);
            } else {
              // this is an ok guid, put an annotation on this row. It is more
              // complicated than just setting annotations here,

              this.validGuids.push(rslt.path);
              /*var annotations = this.editor.getSession().getAnnotations();
              annotations.push({
                row: rslt.lineNo,
                column: 0,
                source: "jsoneditor",
                text: rslt.data,
                type: "info"
              });
              this.editor.getSession().setAnnotations(annotations);*/
            }
          }
          if (allErrs.length) {
            this.onError();
          }
          return allErrs;
        });
      }
      // only regular errors, just return those
      return errors;
    },
    wireEditor() {
      this.editor = this.$refs.jsoneditor.editor.aceEditor;
      this.editor.on("guttermousedown", e => {
        const rowIdx = e.getDocumentPosition().row;
        const rowStr = this.editor.getSession().getLine(rowIdx);
        // see if there is a key in the string using a simple-minded check: look for '":'
        // and if it is found we'll assume it is a valid key in JSON
        if (rowStr.match(/" *:/)) {
          // found a match, popup the list of questions and allow selection of a question,
          // replacing the key on the line with the guid for the question using
          // this.editor.replace();
          this.selectedKey = rowStr.match(/"([^"]+)" ?:/)[0];
          this.selectedRow = rowIdx;

          this.showQuestionsModal();
        }
      });
    }
  },
  mounted() {
    this.getTable("question");
    this.originalJsonData = this.jsonData;
  },
  // props: ["checkingForm", "isProduction", "sendToRegularEndpoint", "showEndpointSwitch"]
  props: {
    checkingForm: null,
    isProduction: null,
    sendToRegularEndpoint: null,
    showEndpointSwitch : {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="scss" scoped>
thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #fff;
  border-bottom: solid 2px #eee;
}

th {
  font-size: 1.5em;
  padding: 5px 10px;
}

.text-label {
  font-size: 1em;
  line-height: 1.2em;
  font-weight: bold;
}

.from-title {
  text-align: right;
}
.error-message {
  margin-top: 2em;
}

.record-list {
  max-height: calc(100vh - 360px);
  overflow: auto;
  ul {
    list-style: none;
    font-size: 16px;
    padding-left: 0;
  }
  li {
    margin-bottom: 20px;

    a {
      display: block;
      padding: 5px 10px;
    }

    //Need to use v-deep since the style in this component is "scoped" which
    // encapsulates the 'li's above (https://stackoverflow.com/a/55368933)
    ::v-deep span {
      font-size: 14px;
      color: #777;
      font-style: italic;
    }
  }
}
.search {
  margin-bottom: 20px;
}
.email-subscribe {
  font-weight: bold;
  background: #f6f6f6;
}
.no-bottom-margin {
  margin-bottom: 0;
}
</style>
